import React, {useEffect, useRef, useState} from 'react';
import {Helmet} from "react-helmet";
import {RouteHelper, RouteInfo} from "../../route/RouteHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import "./Dashboard.scss";
import PointsStatistics from "../../component/statistics/PointsStatistics";
import DigitalClock from "../../component/dashboard/digitalClock/DigitalClock";
import useDraggableScroll from "use-draggable-scroll";
import {
    RaikoBaseCardContainer, RaikoCustomTable,
    RaikoDayGreeting,
    RaikoGridOneColumn,
    RaikoSectionContainer,
    SidebarHolidaysList,
    RaikoCustomSimpleChip,
    RaikoChipTypes,
    showErrorMessage, convertCurrencyFormatPositiveNegative,
    RaikoDefaultDialogPage,
    DialogSize, RaikoBaseContainer
} from '@moeindal/base-raiko-panel-components'
import {convertCurrencyFormat} from "../../util/numberConvertor";
import {LoadingHelper} from "../../util/LoadingHelper";
import {DashboardService} from "../../serverService/dashboardService/DashboardService";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {ContactUsService} from "../../serverService/contactUsService/ContactUsService";
import {css} from "@emotion/css";
import TicketInDashboard from "./TicketInDashboard";
import {useNavigate} from "react-router-dom";
import ShowMessageInfo from "../contactUs/ShowMessageInfo";
import {useAuthState} from "../../context/AuthContext";
import {AdminRoles} from "../../context/reducer";


const Dashboard = () => {
    const {role: roles = []} = useAuthState();

    const service = new DashboardService()

    const [adminFirstName, setAdminFirstName] = useState("");
    const [page, setPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [numberOfItems, setNumberOfItems] = useState(0)
    let size = 20;


    //drag-start
    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});
    //drag-end

    const [reports, setReports] = useState({
        cashBalance: 0,
        unionTotalBalance: 0,
        totalLoansAmount: 0,
        countOfFunds: 0,
        countOfGroups: 0,
        countOfMembers: 0,
    });
    const loading = new LoadingHelper(useLoadingDispatcher())

    useEffect(() => {
        if (roles.includes(AdminRoles.SUPER_ADMIN.role) || roles.includes(AdminRoles.FUND_MANAGER.role))
            getFundsStatusListFromServer()

    }, []);

    useEffect(() => {
        if (typeof service !== "undefined") {
            getDashboardInfoFromServer()
        }
    }, [])

    useEffect(() => {
        if (typeof contactUsService !== 'undefined') {
            if (roles.includes(AdminRoles.SUPER_ADMIN.role) || roles.includes(AdminRoles.SITE_MANAGER.role))
                getTicketListFromServer()
        }
    }, []);

    function getDashboardInfoFromServer() {
        if (roles.includes(AdminRoles.SUPER_ADMIN.role) || roles.includes(AdminRoles.FUND_MANAGER.role)) {
            loading.show()
            service.getDashboardInfo().then(
                response => {
                    setReports(response)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }

    }

    const [tableLoading, setTableLoading] = useState(false);
    const [searchItem, setSearchItem] = useState("")
    const [filter, setFilter] = useState("")
    const [items, setItems] = useState([])

    function prepareFundTableData(id, rowNumber, fundCash, fundName, cashBalance,
                                  totalBalance, countOfGroup, countOfMember, address, status) {
        return {
            id: id,
            number: rowNumber,
            code: fundCash ? convertCurrencyFormat(fundCash) : "0",
            boxName: fundName,
            inventory: cashBalance ? convertCurrencyFormat(cashBalance) : "0",
            totalBalance: totalBalance ? convertCurrencyFormat(totalBalance) : "0",
            countOfGroup: countOfGroup ? countOfGroup : "0",
            countOfMember: countOfMember ? countOfMember : "0",
            address: address,
            status: status ? <RaikoCustomSimpleChip title={"فعال"} type={RaikoChipTypes.success}/>
                : <RaikoCustomSimpleChip title={"غیر فعال"} type={RaikoChipTypes.error}/>,
        }
    }

    function getFundsStatusListFromServer() {
        setTableLoading(true)
        service.getFundsStatusList(page, size)
            .then(response => {
                    setItems([])
                    response.data.map((item, index) => {
                        setItems((prevState => [
                            ...prevState,
                            prepareFundTableData(
                                item.id,
                                (page * 20) + index + 1,
                                item.id,
                                item.name,
                                item.cashBalance,
                                item.totalBalance,
                                item.countOfGroup,
                                item.countOfMember,
                                item.postalAddress,
                                item.enabled
                            )
                        ]))
                    })
                    setPageCount(response.totalPage)
                    setNumberOfItems(response.numberOfItems)
                }
            ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    function handleChangePage(newPage) {
        setPage(newPage)
        getFundsStatusListFromServer()
    }

    const contactUsService = new ContactUsService()


    const [ticketData, setTicketData] = useState([])


    function getTicketListFromServer() {
        loading.show()
        contactUsService.getContactUsList(0, 3).then(
            response => {
                setTicketData(response.data)
            }
        ).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })

    }

    const navigate = useNavigate()

    function showContactUsPage() {
        navigate(RouteHelper.ContactUs.globalUrl)
    }

    const [openDialogState, setOpenDialogState] = useState(false)
    const [messageId, setMessageId] = useState(-1);
    const [refresh, setRefresh] = useState(false)

    function handleCloseDialog() {
        setOpenDialogState(false)
        setMessageId(-1)
        if (refresh) {
            getTicketListFromServer()
        }
    }


    return (
        <>
            <Helmet>
                <title>{RouteInfo.Dashboard.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                pageTitle={"جزئیات پیام"}
                open={openDialogState}
                dialogSize={DialogSize.MEDIUM}
                onClose={handleCloseDialog}
            >
                <ShowMessageInfo messageId={messageId} setRefresh={setRefresh}
                                 handleCloseDialog={handleCloseDialog}/>
            </RaikoDefaultDialogPage>
            <RaikoBaseContainer>
                <RaikoDayGreeting
                    adminName={adminFirstName}
                    dayGreetingSubtitle={"خلاصه ی آخرین وضعیت سامانه"}
                />
            </RaikoBaseContainer>
            <section className="dashboardLayout">
                <div className="dashboardContent">

                    {
                        roles.includes(AdminRoles.SUPER_ADMIN.role) || roles.includes(AdminRoles.FUND_MANAGER.role) ?
                        <div className="statisticsLayout hideScroll">
                        <PointsStatistics
                            title={"مجموع پس انداز (ریال)"}
                            amount={convertCurrencyFormatPositiveNegative(reports.cashBalance)}
                        />
                        <PointsStatistics
                            title={"موجودی اتحادیه (ریال)"}
                            amount={convertCurrencyFormatPositiveNegative(reports.unionTotalBalance)}
                        />
                        <PointsStatistics
                            title={"مجموع وام (ریال)"}
                            amount={convertCurrencyFormatPositiveNegative(reports.totalLoansAmount)}
                        />
                        <PointsStatistics
                            title={"تعداد صندوق ها"}
                            amount={convertCurrencyFormatPositiveNegative(reports.countOfFunds)}
                        />
                        <PointsStatistics
                            title={"تعداد اعضا"}
                            amount={convertCurrencyFormatPositiveNegative(reports.countOfMembers)}
                        />
                        <PointsStatistics
                            title={"تعداد گروه ها"}
                            amount={reports.countOfGroups}
                        />
                        {/*<VisitStatistics/>*/}
                        {/*<ProductStatistics/>*/}
                        {/*<PointsStatistics/>*/}
                        {/*<CommentsStatistics/>*/}
                        {/*<CommentsStatistics/>*/}

                    </div>:""}
                    {
                        roles.includes(AdminRoles.SUPER_ADMIN.role) || roles.includes(AdminRoles.FUND_MANAGER.role) ?
                        <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoSectionContainer title={"خلاصه وضعیت صندوق ها"}
                            >
                                <RaikoCustomTable
                                    isLoading={tableLoading}
                                    data={items}
                                    header={columns}
                                    pageCount={pageCount}
                                    handlePaginationChange={handleChangePage}
                                />
                            </RaikoSectionContainer>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>:""}

                    {
                        roles.includes(AdminRoles.SITE_MANAGER.role) ?
                            <RaikoBaseCardContainer>
                                <RaikoSectionContainer
                                    title={"تیکت ها"}
                                    secondaryButtonTitle={"مشاهده همه"}
                                    hasSecondaryButton={true}
                                    secondaryButtonOnClick={showContactUsPage}>
                                    <div className={css`display: flex;
                              flex-direction: column;
                              gap: 0.5rem`}>
                                        {
                                            ticketData.map((item, index) => {
                                                return <TicketInDashboard
                                                    handleShowMessageInDashboard={_ => {
                                                        setMessageId(item.id)
                                                        setOpenDialogState(true)
                                                    }}
                                                    key={index}
                                                    title={item.title}
                                                    firstName={item.firstName}
                                                    sendAt={item.sendAt}
                                                    status={item.status}
                                                />
                                            })
                                        }
                                    </div>
                                </RaikoSectionContainer>
                            </RaikoBaseCardContainer>:""
                    }

                </div>
                <div className="dashboardWrapper">
                    <DigitalClock/>
                    <div className="dashboardWrapperTicketContainer">
                        {
                            roles.includes(AdminRoles.SUPER_ADMIN.role) ?
                                <RaikoBaseCardContainer>
                                    <RaikoSectionContainer
                                        title={"تیکت ها"}
                                        secondaryButtonTitle={"مشاهده همه"}
                                        hasSecondaryButton={true}
                                        secondaryButtonOnClick={showContactUsPage}>
                                        <div className={css`display: flex;
                              flex-direction: column;
                              gap: 0.5rem`}>
                                            {
                                                ticketData.map((item, index) => {
                                                    return <TicketInDashboard
                                                        handleShowMessageInDashboard={_ => {
                                                            setMessageId(item.id)
                                                            setOpenDialogState(true)
                                                        }}
                                                        key={index}
                                                        title={item.title}
                                                        firstName={item.firstName}
                                                        sendAt={item.sendAt}
                                                        status={item.status}
                                                    />
                                                })
                                            }
                                        </div>
                                    </RaikoSectionContainer>
                                </RaikoBaseCardContainer>:""}
                        <SidebarHolidaysList/>
                    </div>
                    {/*<GeneralStoreInformation storeName={storeName}/>*/}
                    {/*<EducationalVideosInDashboardPage/>*/}
                    {/*<DailyNotifications/>*/}
                </div>

            </section>
        </>

    )
}

export default Dashboard;
const columns = [
    {
        id: 'number',
        label: '#',
    },
    {
        id: 'code',
        label: 'کد صندوق',
    },
    {
        id: 'boxName',
        label: 'نام صندوق',
    },
    {
        id: 'inventory',
        label: 'مجموع پس انداز (ریال)',
    },
    {
        id: 'totalBalance',
        label: 'موجودی کل (ریال)',
    },
    {
        id: 'countOfGroup',
        label: 'تعداد گروه ها',
    },
    {
        id: 'countOfMember',
        label: 'تعداد اعضا',
    },
    {
        id: 'address',
        label: 'آدرس',
    },
    {
        id: 'status',
        label: 'وضعیت',
    },
];